import API from '~/apis/client'

export async function create(payload: object) {
  return await API.handle(API.public.post(`/public/v1/xendit_tests`, payload))
}
